<ng-template #modalTemplate>
  <button
    type="button"
    class="info-modal-close"
    aria-label="Close"
    (click)="modalRef.close()"
  >
    <span aria-hidden="true">×</span>
  </button>
  <div
    class="modal-content-holder"
    [ngClass]="popoverInfo!.contentText ? 'middle' : ''"
  >
    <h4 class="modal-title" *ngIf="title">{{ title | msg | async }}</h4>
    <app-popover-content [popoverInfo]="popoverInfo"></app-popover-content>
  </div>
</ng-template>
